module.exports = __webpack_public_path__ + "a6f76650e6d8008adb1a4c085938d150.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/nachos.png
// module id = 2565
// module chunks = 0